export default __webpack_public_path__ + "static/media/icon_tc_black.cf79a7a9.png";